export enum PickingOrderType {
  RECEIVED = 'RECEIVED',
  PLANNED = 'PLANNED',
  EXPEDITION = 'EXPEDITION',
  IN_SEPARATION = 'IN_SEPARATION'
}
